/**
 * 오라클 성능 분석 › 설정 탭(2026-10-16)의 매핑 도우미 — 대기 ↔ 시스템 메트릭, 대기 ↔ 설정 파라미터 두 매핑이 **같은 모양**이라 함께 쓴다.
 * 모양: { "<키>": ["항목", …] } — 키 = 대기 이름 · `class:<대기 그룹>` · `*`. 사용자 것은 **고친 키만** 담는다(기본값과 같아지면 지운다).
 * 기본값은 메트릭이 화면(`waitMetricMap.DEFAULT_MAP`), 파라미터가 서버(`/param-defaults`) — 받아서 넘긴다. 순수 함수만.
 */
export const ANY_KEY = '*';

const listOf = (v) => (Array.isArray(v) ? v : null);

/** 편집할 키의 지금 값 — 사용자 것이 있으면 그것, 없으면 기본값(그 키에 정확히 걸린 것만) */
export function itemsForKey(key, userMap, defaults) {
  const u = listOf((userMap || {})[key]);
  if (u) return { source: 'user', items: u };
  const d = listOf((defaults || {})[key]);
  return d ? { source: 'default', items: d } : { source: 'none', items: [] };
}

/** 키 하나를 적는다. 기본값과 같아지면(순서까지) 지운다 — 고친 것만 남긴다 */
export function withItems(userMap, defaults, key, items) {
  const next = { ...(userMap || {}) };
  const list = [...new Set((items || []).filter(Boolean))];
  const def = listOf((defaults || {})[key]);
  if (def && def.length === list.length && def.every((m, i) => m === list[i])) delete next[key];
  else next[key] = list;
  return next;
}

export function withoutKey(userMap, key) {
  const next = { ...(userMap || {}) };
  delete next[key];
  return next;
}

/** 왼쪽 목록 — 기본값의 키 + 사용자가 더한 키. `*` → 대기 그룹 → 이벤트(이름순). `@…`(화면이 쓰는 내부 키)는 뺀다 */
export function keysOf(userMap, defaults) {
  const keys = new Set([...Object.keys(defaults || {}), ...Object.keys(userMap || {})].filter(k => !k.startsWith('@')));
  const rank = (k) => (k === ANY_KEY ? 0 : (k.startsWith('class:') ? 1 : (k === 'ON CPU' ? 2 : 3)));
  return [...keys].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
}

/** 기본값과 견준 차이 — 항목마다 「추가」 · 「뺌」 표시에 쓴다 */
export function diffOf(key, items, defaults) {
  const def = listOf((defaults || {})[key]) || [];
  return { added: items.filter(i => !def.includes(i)), removed: def.filter(i => !items.includes(i)) };
}

/** 고친 키 수(`@…` 제외) — 공개 목록·요약에 */
export function changedCount(userMap) {
  return Object.keys(userMap || {}).filter(k => !k.startsWith('@')).length;
}
